import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LoadingSpinner from '../components/loadingSpinner'

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        margin: '32px',
        justifyContent: 'center',
        alignItems: 'center',
    },
}))

const LoadingPage = ({ text }) => {
    const classes = useStyles()
    return (
        <div className={classes.container}>
            <LoadingSpinner text={text} />
        </div>
    )
}

export default LoadingPage
